<dx-popup
  [width]="520"
  [height]="330"
  [showTitle]="true"
  [title]="'USER-NAV.CHANGE-PASSWORD' | translate"
  [dragEnabled]="false"
  [hideOnOutsideClick]="true"
  [showCloseButton]="true"
  class="modal"
  [classList]="'modal'"
  [visible]="showModal"
  (onHidden)="closeModal()"
  [wrapperAttr]="{ class: 'change-password-popup' }"
>
  <dxi-popup-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="{
      stylingMode: 'contained',
      text: 'USER-NAV.CHANGE-PASSWORD' | translate,
      onClick: submit
    }"
  ></dxi-popup-toolbar-item>
  <div *dxTemplate="let data of 'content'">
    <p>{{ 'USER-NAV.CHANGE-PASSWORD-MODAL.PASSWORD-HINT' | translate }}</p>
    <dx-form #form [formData]="formData" labelMode="floating">
      <dxi-item
        dataField="password"
        editorType="dxTextBox"
        [editorOptions]="{
          mode: passwordVisible ? 'text' : 'password',
          hint:('USER-NAV.CHANGE-PASSWORD-MODAL.PASSWORD-HINT' | translate),
          buttons: [
            'clear',
            {
              name: 'password',
              location: 'after',
              options: {
                icon: passwordVisible ? 'eyeopen' : 'eyeclose',
                onClick: togglePasswordVisibility,
                elementAttr: { class: 'dx-button-password' }
              }
            }
          ]    
        }"
      >
        <dxo-label
          [text]="'USER-NAV.CHANGE-PASSWORD-MODAL.NEW-PASSWORD' | translate"
        ></dxo-label>

        <dxi-validation-rule
          type="required"
          [message]="'USER-NAV.CHANGE-PASSWORD-MODAL.PASSWORD-IS-REQUIRED' | translate"
        ></dxi-validation-rule>
        <dxi-validation-rule
          type="custom"
          [message]="'USER-NAV.CHANGE-PASSWORD-MODAL.PASSWORD-HINT' | translate"
          [validationCallback]="passwordComplexityCheck"
        ></dxi-validation-rule>
      </dxi-item>

      <dxi-item
        dataField="repeatPassword"
        editorType="dxTextBox"
        [editorOptions]="{
          mode: repeatPasswordVisible ? 'text' : 'password',
          hint: ('USER-NAV.CHANGE-PASSWORD-MODAL.REPEAT-PASSWORD-HINT' | translate),
          placeholder: ('USER-NAV.CHANGE-PASSWORD-MODAL.REPEAT-PASSWORD-HINT' | translate),
          buttons: [
            'clear',
            {
              name: 'password',
              location: 'after',
              options: {
                icon: repeatPasswordVisible ? 'eyeopen' : 'eyeclose',
                onClick: toggleRepeatPasswordVisibility,
                elementAttr: { class: 'dx-button-password' }
              }
            }
          ]
        }"
      >
        <dxo-label
          [text]="'USER-NAV.CHANGE-PASSWORD-MODAL.REPEAT-PASSWORD' | translate"
        ></dxo-label>

        <dxi-validation-rule
          type="required"
          [message]="'USER-NAV.CHANGE-PASSWORD-MODAL.PASSWORD-IS-REQUIRED' | translate"
        ></dxi-validation-rule>
        <dxi-validation-rule
          type="custom"
          [message]="'USER-NAV.CHANGE-PASSWORD-MODAL.PASSWORDS-DO-NOT-MATCH' | translate"
          [validationCallback]="repeatPasswordValidation"
        ></dxi-validation-rule>
      </dxi-item>
    </dx-form>
  </div>
</dx-popup>
